import {h, Fragment} from "preact"
import { defaultConfig } from "../config"
import { HistoryElement, useAppStateSelector } from "@nosto/preact"
import { popularSearches, popularCollections, pages } from "../helpers"
import { useEffect, useRef } from "preact/hooks"

export default function History() {
    const historyItems = useAppStateSelector(state => state.historyItems)
    const parentRef = useRef(null);
    // if (!historyItems || !historyItems.length) {
    //     return
    // }
    useEffect(()=>{
        if(window.nostojs){
            window.nostojs(api => {
                api
                .createRecommendationRequest({ includeTagging: true })
                .setElements([ "ns-autocomplete-rec" ])
                .load({ skipPageViews: true, skipEvents: true })
            })
        }
    }, [])

    useEffect(() => {
        const body = document.body;

        // Function to toggle the `ns-overflow-hidden` class
        const toggleBodyClass = () => {
            const parentElement = parentRef.current?.parentNode; // Get the parent of `ns-autocomplete`
            if (parentElement && getComputedStyle(parentElement).display === "none") {
                body.classList.remove("ns-overflow-hidden");
            } else {
                body.classList.add("ns-overflow-hidden");
            }
        };

        // Observe changes in the parent element's attributes or styles
        const observer = new MutationObserver(() => {
            toggleBodyClass();
        });

        const parentElement = parentRef.current?.parentNode;
        if (parentElement) {
            observer.observe(parentElement, { attributes: true, attributeFilter: ["style", "class"] });
            // Initial check
            toggleBodyClass();
        }

        // Cleanup the observer on component unmount
        return () => {
            observer.disconnect();
        };
    }, []);

    useEffect(() => {
        const calculateHeights = () => {
            const sectionHeader = document.querySelector(".section-header");
            const announcementBar = document.querySelector(".announcement-bar-section");
            const headerSearchMobile = document.querySelector(".header-search__inline");

            // console.log(sectionHeader, announcementBar, headerSearchMobile);

            // && announcementBar
            if (sectionHeader && parentRef.current && window.innerWidth > 989) {
                const sectionHeaderHeight = sectionHeader.offsetHeight || 0;
                const announcementBarHeight = announcementBar.offsetHeight || 0;
                const totalHeight = sectionHeaderHeight + announcementBarHeight;

                parentRef.current.style.maxHeight = `calc(100vh - ${totalHeight}px)`;
            } else if(sectionHeader && announcementBar && parentRef.current && headerSearchMobile && window.innerWidth <= 989){
                const sectionHeaderHeight = sectionHeader.offsetHeight || 0;
                const announcementBarHeight = announcementBar.offsetHeight || 0;
                const headerSearchMobileHeight = headerSearchMobile.offsetHeight || 0;
                 
                const totalHeight = sectionHeaderHeight + headerSearchMobileHeight + announcementBarHeight;

                parentRef.current.style.maxHeight = `calc(100vh - ${totalHeight}px)`;

            }
        };

        // Calculate heights on mount
        calculateHeights();

        // Recalculate heights on window resize
        window.addEventListener("resize", calculateHeights);

        return () => {
            window.removeEventListener("resize", calculateHeights);
        };
    }, []);

    return (
        <div 
        class="ns-autocomplete ns-history ns-absolute ns-d-flex ns-flex-column ns-align-items-start ns-border-box ns-mx-auto"
        ref={parentRef}
        >
            <div class="ns-autocomplete-trending-section">
                <div class="ns-autocomplete-heading ns-uppercase">
                    Trending
                </div>
                <div class="ns-d-flex">
                    {(window.nostoPopularSearches || popularSearches).map((item, index)=>{
                        return (
                            <a href={item?.url} class="ns-popular-search ns-d-block">{item?.name}</a>
                        )
                    })}
                </div>
            </div>
            <div class="ns-d-flex ns-w-100">
                <div class="ns-autocomplete-searches">
                    <div class="ns-autocomplete-section ns-collections-section">
                            <div class="ns-autocomplete-heading ns-uppercase">
                                Collections
                            </div>
                            <div>
                            {(window?.nostoPopularCollections || popularCollections)?.map((category, index)=>{
                                return (
                                    <a key={index} href={category?.url} class="ns-suggested-collection ns-d-block">{category?.name}</a>
                                )
                            })}
                            </div>
                    </div>
                    <div class="ns-autocomplete-section ns-pages-section">
                            <div class="ns-autocomplete-heading ns-uppercase">
                                Pages
                            </div>
                            <div>
                            {(window.nostoPopularPages || pages)?.map((page, index)=>{
                                return (
                                    <a key={index} href={page?.url} class="ns-suggested-page ns-d-block">{page?.name}</a>
                                )
                            })}
                            </div>
                    </div>
                </div>
                <div class="nosto_element" id="ns-autocomplete-rec"></div>
            </div>
        </div>
    )
}


{/* {historyItems?.length > 0 && (
                        <div class="ns-autocomplete-section">
                            <div class="ns-autocomplete-heading">
                                Recent Searches
                            </div>
                            <div>
                                {historyItems?.slice(0, defaultConfig.historySize).map(item => (
                                    <HistoryElement key={item} query={{ query: item }}>
                                        <div class="ns-d-flex flex-row ns-justify-content-between ns-clickable">
                                            {item}
                                        </div>
                                    </HistoryElement>
                                ))}
                            </div>
                        </div>
                    )} */}